/**
 * Zoom, mit dem die interaktive Vorschau TATSÄCHLICH rendert.
 *
 * Der Nutzer-Zoom (Default 1.25, `ZoomControls`) ist für Desktop-Breiten gewählt. In einer
 * schmalen Vorschau (Tablet, Quelltext-Split) passt bei 1.25 oft nur ein Takt pro System – dort
 * wird der Render-Zoom deshalb auf höchstens `NARROW_MAX_ZOOM` gedeckelt. Der Nutzer-Zoom selbst
 * bleibt unverändert (kleinere Werte gelten weiter); ab `NARROW_CONTAINER_PX` greift er voll.
 *
 * Konsumenten von `osmd.zoom` (Hit-Testing, Highlight) lesen den gesetzten Render-Zoom und
 * bleiben damit automatisch konsistent.
 */
export const NARROW_CONTAINER_PX = 700;
export const NARROW_MAX_ZOOM = 1.0;

export function effectiveZoom(containerWidth: number, userZoom: number): number {
    if (containerWidth > 0 && containerWidth < NARROW_CONTAINER_PX) {
        return Math.min(userZoom, NARROW_MAX_ZOOM);
    }
    return userZoom;
}
